import React from 'react'
import PropTypes from 'prop-types'
import { SermonsPageTemplate } from '../../templates/sermons-page'

const SermonsPagePreview = ({ entry, getAsset, widgetFor }) => {
  const data = entry.getIn(['data']).toJS()

  if (data) {
    return (
      <SermonsPageTemplate
        backgroundimage={getAsset(data.backgroundimage)}
        sermonAudio={data.sermonAudio}
        title={entry.getIn(['data', 'title'])}
        passage={entry.getIn(['data', 'passage'])}
        passageLink={entry.getIn(['data', 'passageLink'])}
      />
    )
  } else {
    return <div>Loading...</div>
  }
}

SermonsPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
}

export default SermonsPagePreview
